<template>
	<div class="downloads">
		<div class="card rounded-0 mb-2">
			<div class="card-body text-muted">
				<h5>Descargas</h5>
			</div>
		</div>
		<div class="card rounded-0 text-secondary">
			<div class="card-body">
				<div>
					<div class="row border-bottom px-3 py-2" v-for="(item, index) in listFileDownloadsFilter"
						:key="index">
						<div class="col-11">
							<div class="row">
								<div class="col-md-11">
									{{ item.name }}
								</div>
								<div class="col-md-1">
									{{ item.type }}
								</div>
							</div>
						</div>
						<div class="col-1 text-end">
							<a :href="item.url" download :title="'Peso ' + item.weight">
								<svg class="bi d-block mx-auto mb-1" width="24" height="24">
									<use xlink:href="#download" />
								</svg>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import mixin from '@/mixins'
import axiosAWN from '@/mixins/axiosAWN.js'
import fileDownload from '@/mixins/fileDownload.js'

export default {
	name: 'Downloads',
	mixins: [mixin, fileDownload, axiosAWN],
	data() {
		return {
		}
	},
	computed: {
		listFileDownloadsFilter() {
			return this.listFileDownloads.filter(fd => {
				return fd.status_id == 1
			})
		}
	},
	methods: {
		initModule() {
			this.getAllFileDownloads()
		}
	},
	mounted() {
		this.initModule()
	}
}
</script>
